/* src/app/navigation-footer/navigation-footer.component.css */
#footer_text {
  color: #e4e4e4;
}
#footer_text .btn {
  background: none;
  border: none;
  min-width: 72px;
  min-height: 40px;
}
#footer_text .btn:hover,
#footer_text .btn:active,
#footer_text .btn:focus {
  color: #ffe787;
  font-weight: 600;
  outline: none;
}
.fixed-bottom.navbar-nc {
  width: 100%;
}
.fixed-bottom.navbar-nc .row {
  width: 100%;
}
.navbar {
  padding-left: 0;
  padding-right: 0;
}
.govWarningText {
  margin-top: 15px;
  color: #ffffff;
  font-size: 80%;
}
/*# sourceMappingURL=navigation-footer.component.css.map */
